module.exports = __webpack_public_path__ + "img/ShotaArveladze.bbefea1b.png";